export type SnLayoutItemClickHandler = (event?: MouseEvent) => void;
